<div class="content-wrapper">
  <div class="row">


    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Skills</h4>
          <div class="table-responsive pt-3">
            <table class="table table--striped table-hover">
              <thead>
                <tr>
                  <th>
                    S/N
                  </th>

                  <th>
                    Name
                  </th>
                  <th>
                    Description
                  </th>
                  <!-- <th>
                    Status
                  </th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of Skills; let i = index">
                  
                  <td style="width:0px;">
                    {{i + 1}}
                  </td>

                  <td>
                    {{data.name}}
                  </td>

                  <td>
                    {{data.description}}
                  </td>

                  <!-- <td>
                    {{data.isActive}}
                  </td> -->
                  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>